import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _f3ee05b8 = () => interopDefault(import('../../../pages/about.vue' /* webpackChunkName: "pages/about" */))
const _7f626ab8 = () => interopDefault(import('../../../pages/create/index.vue' /* webpackChunkName: "pages/create/index" */))
const _f35a73b4 = () => interopDefault(import('../../../pages/create-collection.vue' /* webpackChunkName: "pages/create-collection" */))
const _19ccf422 = () => interopDefault(import('../../../pages/discover.vue' /* webpackChunkName: "pages/discover" */))
const _8f5a750a = () => interopDefault(import('../../../pages/drops.vue' /* webpackChunkName: "pages/drops" */))
const _3631e975 = () => interopDefault(import('../../../pages/ebo-token.vue' /* webpackChunkName: "pages/ebo-token" */))
const _54bc6826 = () => interopDefault(import('../../../pages/faq.vue' /* webpackChunkName: "pages/faq" */))
const _1912e948 = () => interopDefault(import('../../../pages/settings.vue' /* webpackChunkName: "pages/settings" */))
const _cdf83d68 = () => interopDefault(import('../../../pages/swap.vue' /* webpackChunkName: "pages/swap" */))
const _81f44c5a = () => interopDefault(import('../../../pages/templates/index.vue' /* webpackChunkName: "pages/templates/index" */))
const _73164bec = () => interopDefault(import('../../../pages/create/mint.vue' /* webpackChunkName: "pages/create/mint" */))
const _66693427 = () => interopDefault(import('../../../pages/details/render/_id.vue' /* webpackChunkName: "pages/details/render/_id" */))
const _94724278 = () => interopDefault(import('../../../pages/details/_id.vue' /* webpackChunkName: "pages/details/_id" */))
const _cd9365e4 = () => interopDefault(import('../../../pages/experience/_id.vue' /* webpackChunkName: "pages/experience/_id" */))
const _507a9abc = () => interopDefault(import('../../../pages/overview/_address.vue' /* webpackChunkName: "pages/overview/_address" */))
const _7303c1aa = () => interopDefault(import('../../../pages/profile/_id.vue' /* webpackChunkName: "pages/profile/_id" */))
const _2bd634fb = () => interopDefault(import('../../../pages/templates/_id.vue' /* webpackChunkName: "pages/templates/_id" */))
const _59c6cbe1 = () => interopDefault(import('../../../pages/tokens/_address.vue' /* webpackChunkName: "pages/tokens/_address" */))
const _08b1a4c6 = () => interopDefault(import('../../../pages/transactions/_address.vue' /* webpackChunkName: "pages/transactions/_address" */))
const _b47e502e = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/about",
    component: _f3ee05b8,
    name: "about"
  }, {
    path: "/create",
    component: _7f626ab8,
    name: "create"
  }, {
    path: "/create-collection",
    component: _f35a73b4,
    name: "create-collection"
  }, {
    path: "/discover",
    component: _19ccf422,
    name: "discover"
  }, {
    path: "/drops",
    component: _8f5a750a,
    name: "drops"
  }, {
    path: "/ebo-token",
    component: _3631e975,
    name: "ebo-token"
  }, {
    path: "/faq",
    component: _54bc6826,
    name: "faq"
  }, {
    path: "/settings",
    component: _1912e948,
    name: "settings"
  }, {
    path: "/swap",
    component: _cdf83d68,
    name: "swap"
  }, {
    path: "/templates",
    component: _81f44c5a,
    name: "templates"
  }, {
    path: "/create/mint",
    component: _73164bec,
    name: "create-mint"
  }, {
    path: "/details/render/:id?",
    component: _66693427,
    name: "details-render-id"
  }, {
    path: "/details/:id?",
    component: _94724278,
    name: "details-id"
  }, {
    path: "/experience/:id?",
    component: _cd9365e4,
    name: "experience-id"
  }, {
    path: "/overview/:address?",
    component: _507a9abc,
    name: "overview-address"
  }, {
    path: "/profile/:id?",
    component: _7303c1aa,
    name: "profile-id"
  }, {
    path: "/templates/:id",
    component: _2bd634fb,
    name: "templates-id"
  }, {
    path: "/tokens/:address?",
    component: _59c6cbe1,
    name: "tokens-address"
  }, {
    path: "/transactions/:address?",
    component: _08b1a4c6,
    name: "transactions-address"
  }, {
    path: "/",
    component: _b47e502e,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
